import * as $ from "jquery";

export class Scroll {
    public static scrollTop(): void {
        $("html, body").animate({ scrollTop: 0 }, "fast");
    }

    /*
        * Scroll to an element.
        * Params: - elem - element to be scrolled into top of the viewport
                - treshold - if the the top of the element (including the topOffset, mentioned below)
                    is already in the specified part of the viewport no scrolling will happen
                            - value needs to be from interval [0, 1]:
                                - 0 turns this functionality off
                                - 1 means that if the top of the element is anywhere in the viewport already,
                                    no scrolling will happen
                                - 0.5 (default) means that if the top of the element is in the top half of
                                    the viewport no scrolling will happen
                - topOffset - margin from the top of the viewport the element will be scrolled to in px
                            - it also affects the condition whether the scrollin will happen or not (see treshold param)
                - scrollableParent - if the elem has some parent element with scrollbar which should be scrolled
                    intead of the whole page, add it as this param
                                    - when not specified, whole page is scrolled
        */
    public static scrollToElement(elem: Element, threshold = 0.5, topOffset = 40, scrollableParent?: Element): void {
        if (!elem) {
            return;
        }

        const $elem = $(elem);

        if (scrollableParent) {
            const $scrollableParent = $(scrollableParent);
            const scrollOffset = $elem ? $elem.offset().top - $scrollableParent.offset().top - topOffset : 0;
            if (
                scrollOffset < $scrollableParent.scrollTop() ||
                scrollOffset > $scrollableParent.scrollTop() + $scrollableParent.height() * threshold
            ) {
                $scrollableParent.animate(
                    {
                        scrollTop: scrollOffset,
                    },
                    "fast"
                );
            }
        } else {
            const scrollOffset = $elem ? $elem.offset().top - topOffset : 0;
            if (
                scrollOffset < window.pageYOffset ||
                scrollOffset > window.pageYOffset + $(window).height() * threshold
            ) {
                $("html, body").animate(
                    {
                        scrollTop: scrollOffset,
                    },
                    "fast"
                );
            }
        }
    }

    /*
     * Scroll to an element and focus it.
     * If the element itself can't be focused, first focusable child is focused instead.
     * Params are tha same as in the scrollToElement().
     */

    public static focusElement(elem: Element, threshold = 0.5, topOffset = 40, scrollableParent?: Element): void {
        if (!elem) {
            return;
        }

        const focusableElements = `
                a[href], area[href], input:not([disabled]),
                select:not([disabled]), textarea:not([disabled]),
                button:not([disabled]), iframe, object, embed, *[tabindex],
                *[contenteditable]`;
        const $elem = $(elem);

        Scroll.scrollToElement(elem, threshold, topOffset, scrollableParent);

        if ($elem.is(focusableElements)) {
            $elem.focus();
        } else {
            $elem.find(focusableElements).first().focus();
        }
    }
}
